/**
 * versionreducer.js
 * Created by calhosh on 9/22/2020.
 */
import initialState from './initialstate';
export default function VersionUpgradeStateReducer(
	state = initialState.appVersion,
	action
) {
	switch (action.type) {
		case 'VERSION_UPDATE':
			return {
				upgrade: action.upgrade,
				version: action.version
			};
		default:
			return state;
	}
}
